import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  selector: 'app-dropdown-menu-option',
  imports: [NgClass],
  templateUrl: './dropdown-menu-option.component.html',
  styleUrl: './dropdown-menu-option.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DropdownMenuOptionComponent {
  public buttonClasses = input<string>();
  public disabled = input(false);
}
